<template>
  <div class="card editable-card">
      <div style="display: flex;">
        <div class="links-body">
          <div class="statBlock">
            <div class="card-header" v-if="$slots.header">
              <slot name="header"></slot>
            </div>
            <div class="card-body">
              <div>Cool Text</div>
            </div>
            <!--<a href="#" class="edit-button">Edit</a>-->
            <div class="card-footer" v-if="$slots.footer">
              <slot name="footer"></slot>
            </div>
          </div>
      </div>
    </div>
  </div>

</template>
<script>
  import Card from '../Card.vue'

  export default {
    name: 'editable-card',
    components: {
      Card
    },
    props: {
    },
    data () {
      return {
      }
    },
  }
</script>
<style>
.editable-card {
  height: calc(100% - 30px);
}

/*.edit-button {
    display: block !important;
    width: calc(100% - 10px);
    text-align: center;
    border-top: 1px solid #dfdfdf;
    font-size: 0.8em;
    margin-bottom: 5px;
    margin-left: 5px;
    margin-top: 30px;
}*/

.links-body {
    width: 100% !important;
}
</style>